import { styled } from 'styled-components';
import { device } from '@/styles/helpers';

export const ScBonusList = styled.div`
  & .title {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 24px;
    text-align: center;
  }

  @media (${device.mobile}) {
    .title {
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 16px;
    }
  }
`;
